/* eslint-disable */
// import url_config from '@/config/local.js';
// import url_config from '@/config/dev.js'; 
// import url_config from '@/config/staging.js';
import url_config from '@/config/prod.js';
let is_local = window.location.origin == 'http://localhost:8080'

export default {
  ...url_config,
  defaultLocale : "en",
	localeOptions : [
    {id:'de',name:'German'},
    {id:'en',name:'English'},
    {id:'id',name:'Indonesia'},
    {id:'ja',name:'Japanese'},
    {id:'ru',name:'Russian'},
    {id:'zh',name:'Chinese'}
	],
  currencyConvertApiKey: 'bad5acb83ac091bcce20',
  QISCUS_APPID: 'guestpro-nm6jdwqrtxl2',
  GMAPS_KEY: is_local ? 'AIzaSyA_u8VJElUj-vM9lpsFDEQpkyy9BgYWjco' : 'AIzaSyCNJgw0NS4P9JVexjc3XPYdbm9Xd_IZEqc'
}


// WEBPACK FOOTER //
// ./src/config/index.js